type OnFileDownload = (params: {
  file_extension: string
  file_name: string
  link_text: string
  link_url: string
}) => void

const TRACKED_EXTENSIONS = new Set([
  'pdf',
  'xlsx',
  'xls',
  'docx',
  'doc',
  'txt',
  'rtf',
  'csv',
  'exe',
  'key',
  'pps',
  'ppt',
  'pptx',
  '7z',
  'pkg',
  'rar',
  'gz',
  'zip',
  'avi',
  'mov',
  'mp4',
  'mpeg',
  'mpg',
  'wmv',
  'midi',
  'mid',
  'mp3',
  'wav',
  'wma',
])

export const initFileDownloadTracking = (onFileDownload: OnFileDownload): (() => void) => {
  const handler = (event: MouseEvent): void => {
    const target = event.target
    if (!(target instanceof Element)) return
    const anchor = target.closest('a')
    if (!anchor) return
    const href = anchor.getAttribute('href')
    if (!href) return

    let ext: string
    let fileName: string
    try {
      const url = new URL(href, window.location.href)
      const lastSegment = url.pathname.split('/').pop() ?? ''
      const dot = lastSegment.lastIndexOf('.')
      if (dot === -1) return
      ext = lastSegment.slice(dot + 1).toLowerCase()
      fileName = lastSegment
    } catch {
      return
    }

    if (!TRACKED_EXTENSIONS.has(ext)) return

    onFileDownload({
      file_extension: `.${ext}`,
      file_name: fileName,
      link_text: anchor.textContent?.trim() ?? '',
      link_url: anchor.href,
    })
  }

  document.addEventListener('click', handler)
  return () => document.removeEventListener('click', handler)
}
